export default __webpack_public_path__ + "static/media/0j.8b89e816.png";